export default __webpack_public_path__ + "locales/lv/PortalUnavailable.json?hash=a621c8c598a2cc7be3092493688a7cc9";